import React from 'react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '../ui/empty'
import { ModalBody } from '../ui/modal'
import { Spinner } from '../ui/spinner'

function ImportFromFileProcessing() {
	const { t } = useTranslation()

	return (
		<ModalBody className='relative flex flex-col overflow-hidden py-10'>
			<Empty>
				<EmptyHeader>
					<EmptyMedia variant='icon'>
						<Spinner />
					</EmptyMedia>
					<EmptyTitle>{t('og_bulk_import_updating')}</EmptyTitle>
					<EmptyDescription>
						{t('og_bulk_import_updating_hint')}
					</EmptyDescription>
				</EmptyHeader>
			</Empty>
		</ModalBody>
	)
}
export { ImportFromFileProcessing }
